import Cookies from 'vue-cookies'

const state = {
  projectId: window.localStorage.getItem('projectId') || '',
  projectName: window.localStorage.getItem('projectName') || '',
  dataCurrent: window.localStorage.getItem('dataCurrent') || '',
  isLogin: Cookies.get('tokenWeb') ? true : false,
}

export default state



// WEBPACK FOOTER //
// ./src/store/state.js